import { ComponentMeta, ComponentStory } from "@storybook/react";
import React from "react";
import Flex from "../../Flex";
import ProgressCircle from "./ProgressCircle";

type ProgressCircleType = typeof ProgressCircle;

export default {
    title: "Progress Indicators/Progress Circle",
    component: ProgressCircle,
    args: {
        value: 40
    }
} as ComponentMeta<ProgressCircleType>;

const Template: ComponentStory<ProgressCircleType> = args => (
    <Flex spacing={2} alignItems="flex-start">
        <ProgressCircle {...args} size="xs" />
        <ProgressCircle {...args} size="sm" />
        <ProgressCircle {...args} size="md" />
        <ProgressCircle {...args} size="lg" />
    </Flex>
);

export const Default = Template.bind({});

export const Sublabel = Template.bind({});
Sublabel.args = {
    sublabel: "Active users"
};

export const CustomColors = Template.bind({});
CustomColors.args = {
    sublabel: "Sublabel",
    progressColor: "success-400",
    progressBackgroundColor: "success-50",
    labelColor: "success-600",
    sublabelColor: "success-400"
};

export const CustomTextAndRange = Template.bind({});
CustomTextAndRange.args = {
    value: 327,
    maxValue: 500,
    label: (value, _, max) => `${value}/${max}`
};

export const OutOfRange = Template.bind({});
OutOfRange.args = {
    value: -10
};
